import type { OptimizationGroupReviewModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'
import { prop } from 'lodash/fp'

import { client } from '@/shared/api/client'

export const optimizationReviewsQueries = {
	list: () => ({
		queryKey: ['reviews'],
		queryFn: () =>
			client.reviews
				.listOptimizationGroupsReviews()
				.then(prop('objects')) as Promise<OptimizationGroupReviewModel[]>,
	}),
}
export function useOptimizationReviewsQuery<T = OptimizationGroupReviewModel[]>(
	options?: UseQueryOptions<OptimizationGroupReviewModel[], Error, T>
) {
	return useQuery<OptimizationGroupReviewModel[], Error, T>({
		...optimizationReviewsQueries.list(),
		...(options || {}),
	})
}
